import { MutableRefObject, useRef, useState } from "react";
import { Note } from "../../../Data/HexMap/Note";
import { Music } from "../../../Util/Music/Music";
import { ChapterConfig } from "../../ChapterConfig";
import { OutlineBox } from "../../../Comps/OutlineBox/OutlineBox";
import { ChapterNav, ChapterNavItem } from "../ChapterNav/ChapterNav";
import { ClearHelpers } from "../../Helpers/ClearHelpers/ClearHelpers";
import { ChapterRoutes } from "../ChapterNav/ChapterRoutes";
import { TransformTranslate } from "../../../Util/Transform/Transform";
import { BuildHexMap } from "../../../Data/HexMap/HexMapBuilder";
import { HexMap } from "../../../Data/HexMap/HexMap";
import { HexMapModifier } from "../../../Data/HexMap/HexMapModifier";
import { HxMapGroup } from "../../../Comps/HxMap/HxMapGroup";
import { All } from "../../../Util/Constants/Quantities";
import './HexKeyAnatomy.scss'
export function HexKeyAnatomyChapter(props:ChapterConfig){
    const subPaths:ChapterNavItem[] = [
        {title:'Lesson', path:'lesson', element:<ClearHelpers><Lesson/></ClearHelpers>},
    ]
    return  <div>
                <h1>The Anatomy of a HexKey</h1>
                <ChapterNav path={props.path} subPaths={subPaths}/>
                <ChapterRoutes chapterNavs={subPaths}/>
            </div>
}

export function Lesson(){
    const [selectedButton, setSelectedButton] =  useState<number>(-1)
    const positions:number[][] = [[0,5],[1,2],[3,4],[6]]
    const [haloPositions, setHaloPositions] =  useState<number[]>([])
    const [tonic, setTonic] = useState<number>(Music.G)

    const onNoteClick = (note:Note) => {
        const isSame:boolean = (haloPositions[0] === note.params.noteIndex)
        const freshHaloPositions:number[] = (isSame) ? [] : [note.params.noteIndex]
        setHaloPositions(freshHaloPositions)
    }
    const getHexMap = () => {
        const map:HexMap = BuildHexMap({
            rows: 1,
            columns: 1,
            tonic: tonic,
            radius: 100
        })
        const mod:HexMapModifier = new HexMapModifier(map)
        mod.notes_setPrimaryLabelAsPosition([All])
        if(selectedButton > -1){ mod.notes_setHilited(positions[selectedButton]) }
        mod.notes_setHalo(haloPositions, true)
        return map
    }
    const width:number = 600
    const onButtonClick = (buttonNum:number) => {
        setSelectedButton(buttonNum)
    }
    const getSelectedClass = (n:number) => {
        return((n === selectedButton) ? 'selected' : '')
    }
    const centerButton:MutableRefObject<any> = useRef(null)
    const Description = (props:{selectedButton:number}) => {
        const descriptions:JSX.Element[] = [
            <div>
                <h3>The Center Tonics are:</h3>
                <div>
                    <ul>
                        <li>The 1 Position (root of the major 1 chord and the Ionian Mode - the standard major)</li>
                        <li>The 6 Position (root of the minor 6 chord and the Aeolian Mode - the standard minor)</li>
                    </ul>
                    They are the roots of the most commonly used modes.
                </div>
            </div>,
            <div>
                <h3>The Minor Siblings are:</h3>
                <div>
                    <ul>
                        <li>The 2 Position (root of the minor 2 chord and the Dorian Mode - the light minor)</li>
                        <li>The 3 Position (root of the minor 3 chord and the Phrygian Mode - the heavy minor).</li>
                    </ul>
                    They are the only two minor positions that are two notes apart. If you see two minor chords that are two notes apart, they are likely the 2 and 3 chords.
                </div>
            </div>,
            <div>
                <h3>The Major Siblings are:</h3>
                <div>
                    <ul>
                        <li>The 4 Position (root of the major 4 chord and the Lydian Mode - the light major)</li>
                        <li>The 5 Position (root of the major 5 chord and the Mixolydian Mode - the heavy major).</li>
                    </ul>
                    They are the only two major positions that are two notes apart. If you see two major chords that are two notes apart, they are likely the 4 and 5 chords.
                </div>
            </div>,
            <div>
                <h3>The Middle Seven is:</h3>
                <div>
                    <ul>
                        <li>The 7 Position (root of the diminished 7 chord and the Locrian Mode - the inharmonic minor)</li>
                    </ul>
                    This position has a flat 5th so all chords and scales created from it are inharmonic.
                </div>
            </div>
        ]
        return(<div>{descriptions[selectedButton]}</div>)
    }
    return(
        <div className={'hex-key-anatomy Lesson'}>
            <OutlineBox title={'The Regions of the HexKey'} width={width}>
                <div>
                    <svg width={300} height={300}>
                        <g transform={TransformTranslate(300/2,300/2)}>
                            <HxMapGroup onNoteClick={onNoteClick} hexMap={getHexMap()}/>
                        </g>
                    </svg>
                </div>
                <div className={'region-description'}>
                    <Description selectedButton={selectedButton}/>
                </div>
                <div>
                    <button className={getSelectedClass(0)} onClick={()=>{onButtonClick(0)}} type='button'>The Center Tonics</button>
                    <button className={getSelectedClass(1)} onClick={()=>{onButtonClick(1)}} type='button'>The Minor Siblings</button>
                    <button className={getSelectedClass(2)} onClick={()=>{onButtonClick(2)}} type='button'>The Major Siblings</button>
                    <button className={getSelectedClass(3)} onClick={()=>{onButtonClick(3)}} type='button'>The Middle Seven</button>
                </div>
            </OutlineBox>
        </div>
    )
}